"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudManagementTaskStatus = void 0;
var CloudManagementTaskStatus;
(function (CloudManagementTaskStatus) {
    CloudManagementTaskStatus["PENDING"] = "PENDING";
    CloudManagementTaskStatus["SUCCESS"] = "SUCCESS";
    CloudManagementTaskStatus["FAILED"] = "FAILED";
    CloudManagementTaskStatus["UNPROVISIONED"] = "UNPROVISIONED";
    CloudManagementTaskStatus["PRECONFIGURED"] = "PRECONFIGURED";
})(CloudManagementTaskStatus = exports.CloudManagementTaskStatus || (exports.CloudManagementTaskStatus = {}));
//# sourceMappingURL=IdentityProviderConfiguration.js.map